import { render, staticRenderFns } from "./VideoBg.vue?vue&type=template&id=cd13f6e2&scoped=true&"
import script from "./VideoBg.vue?vue&type=script&lang=ts&"
export * from "./VideoBg.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBg.vue?vue&type=style&index=0&id=cd13f6e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd13f6e2",
  null
  
)

export default component.exports